import { useEffect, useRef, useState } from 'react'
import { useForm } from '../contexts/Form.js'
import FormGroup from '../forms/FormGroup'

const useFormBuilder = (options) => {
  const [, forceRender] = useState({})
  const formGroupRef = useRef()
  const form = useForm()
  const formName = options.name || options.formName

  if (!formGroupRef.current) {
    formGroupRef.current = new FormGroup({
      ...options,
      name: formName,
      update: () => {
        if (formName) form.save(formName, formGroupRef.current)
        setTimeout(() => forceRender({}), 100)
      }
  })
}

  useEffect(() => {
    if (formName) form.save(formName, formGroupRef.current)
    forceRender({})
  }, [])

  return { $state: formGroupRef.current }
}

export default useFormBuilder